import React from "react";
import styles from "./AscToogleBox.module.scss";
export type AscToogleBoxProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export default function AscToogleBox({ ...rest }: AscToogleBoxProps) {
  return (
    <label className={styles.switch}>
      <input type="checkbox" {...rest} />
      <span className={styles.slider}></span>
    </label>
  );
}
